import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ReelsFeedProvider } from './contexts/ReelsFeedContext';
import AppRoutes from './routes';
import { ListingProvider } from 'contexts/ListingContext';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <ReelsFeedProvider>
            <ListingProvider>
              <AppRoutes />
            </ListingProvider>
          </ReelsFeedProvider>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
